import Cookies, {expire} from 'cookies-js';

import {getUrlPath} from 'js-utils/path';

import {
    NOTIFICATION_COOKIE,
    ORGANIZER_COOKIE,
    loginModalContainerClassName,
    gdprModalContainerClassName,
    followNotificationContainerClassName,
} from '../constants';


const getContainerParent = (parentClassName) => {
    if (
        typeof parentClassName === 'string' &&
        document.getElementsByClassName(parentClassName).length
    ) {
        return document.getElementsByClassName(parentClassName)[0];
    }

    return document.body;
};
const createContainerOnce = (className, parentClassName) => {
    const containers = document.getElementsByClassName(className);

    let container;

    if (containers.length > 0) {
        container = containers[0];
    } else {
        const newDiv = document.createElement('div');

        newDiv.classList.add(className);

        container = getContainerParent(parentClassName).appendChild(newDiv);
    }

    return container;
};

export const createGDPRContainer = () => createContainerOnce(gdprModalContainerClassName);
export const createLoginModalContainer = () => createContainerOnce(loginModalContainerClassName);
export const createFollowNotificationContainer = (parentClassName) => createContainerOnce(followNotificationContainerClassName, parentClassName);


// Cookies
const hasFollowOrganizerCookie = () => {
    const notificationCookieValue = Cookies.get(NOTIFICATION_COOKIE);

    return notificationCookieValue !== undefined;
};

export const shouldShowGDPRModal = () => !hasFollowOrganizerCookie();

export const getOrganizerIdFromCookie = () => Cookies.get(ORGANIZER_COOKIE);
export const expireOrganizerCookie = () => expire(ORGANIZER_COOKIE, {path: getUrlPath()});